import { z } from "zod/v4"

export const ManageConfigEncryptionKeysDocumentBody = z.object({
  item_planning_key: z.string().describe("アイテムの企画管理フィールド（planning_management_id, planning_name）を AES-CBC で暗号化するための Base64 エンコードされた共通鍵"),
}).describe("管理ツール用の暗号鍵ドキュメント。管理ツール（popopo-manage）でのクライアントサイド暗号化に使用される。")

export type ManageConfigEncryptionKeysDocumentBody = z.infer<typeof ManageConfigEncryptionKeysDocumentBody>

export class ManageConfigDocuments {

  static readonly encryptionKeysId = "encryption-keys"

}
